export const ROUTE_NAMES = {
  root: '/root',
  success: '/success',
  address: '/address',
  pyg: '/pick-your-gift',
  marketplace: '/marketplace',
  pickMsku: '/customize-options',
  customizeItems: '/customize-items',
  error: '/error',
  authentication: '/authentication',
  iframe: '/iframe',
};

export const ROUTE_TEMPLATES = {
  ONE_LINK: '/o/:oneLinkId/:step?',
  SEND: '/s/:orderId/:key/:step?',
};

export const routes = {
  root: '/',
  success: ['/o/:oneLinkId/success', '/s/:orderId/:key/success'],

  address: ['/o/:oneLinkId/address', '/s/:orderId/:key/address'],
  pyg: ['/o/:oneLinkId/pick-your-gift', '/s/:orderId/:key/pick-your-gift'],
  marketplace: ['/o/:oneLinkId/marketplace', '/s/:orderId/:key/marketplace'],
  pickMsku: ['/o/:oneLinkId/customize-options', '/s/:orderId/:key/customize-options'],
  customizeItems: ['/o/:oneLinkId/customize-items', '/s/:orderId/:key/customize-items'],

  error: ['/o/:oneLinkId/error', '/s/:orderId/:key/error', ROUTE_NAMES.error],
  authentication: ['/o/:oneLinkId/authentication', '/s/:orderId/:key/authentication'],
};

export enum IRouterActions {
  BACK = 'POP',
}

export const FLOW_ROUTES = [
  ROUTE_NAMES.pyg,
  ROUTE_NAMES.marketplace,
  ROUTE_NAMES.pickMsku,
  ROUTE_NAMES.customizeItems,
  ROUTE_NAMES.address,
];

export const PICK_YOUR_GIFT_STEP_LABEL = 'Pick your gift';

export const RESULT_ROUTES = [...routes.success, ...routes.error];
export const RESULT_ROUTES_NAMES = [ROUTE_NAMES.success, ROUTE_NAMES.error];

export const CLAIM_STEPS = [...FLOW_ROUTES, ...RESULT_ROUTES_NAMES, ROUTE_NAMES.authentication].map((route) =>
  route.slice(1),
);
